import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import './Tile.css';
import icon from '../images/LMS_logo_Icon.svg';

export const TILES = {
  'customers': 'lets',
  'services': 'make',
  'projects': 'sense',
  'contact': 'say',
};

class Tile extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.id = "tile-" + TILES[props.name];
  }

  getLabel() {
    if(this.props.name === 'customers'){
      return <h1>Let<span className="logocolor">'</span>s</h1>;
    }
    else if(this.props.name === 'contact'){
      return <img src={icon} className="logo-icon" alt="Let's make sense Logo" />;
    }
    else{
      return <h1>{TILES[this.props.name]}</h1>;
    }
  }

  render() {
    let classes = "tile";
    const url = "/" + this.props.name;
    if(this.props.minified){
      classes += " minified";
    }
    else if(!this.props.intro) {
      classes += " active";
    //   return <div className={classes} id={this.id}>{this.getLabel()}</div>;
    }
    // else{
      return <Link to={url} className={classes} id={this.id}>
        {this.getLabel()}
      </Link>;
    // }
  }
}

export default Tile;


// WEBPACK FOOTER //
// ./src/components/Tile.js